// header
(() => {
  // 電腦
  const header = document.querySelector('.header');
  if (!header) return;

  const dropdownOpenCloseBtn = document.querySelector('.dropdown-open-btn');
  const dropdownMenuInner = document.querySelector('.dropdown-menu-inner');

  dropdownOpenCloseBtn.addEventListener('mouseenter', () => {
    header.classList.add('mode-hover');
    dropdownMenuInner.classList.add('show');
  });

  dropdownOpenCloseBtn.addEventListener('mouseleave', () => {
    header.classList.remove('mode-hover');
    dropdownMenuInner.classList.remove('show');
  });

  // 捲動隱藏顯示 header
  document.addEventListener('scroll', () => {
    const scrollY = window.scrollY;
    if (scrollY > 110) {
      header.classList.add('mode-2');
    }
    if (scrollY > 300) {
      header.classList.add('mode-3');
    }
    if (scrollY > 500) {
      header.classList.add('mode-4');
    }
    if (scrollY <= 500) {
      header.classList.remove('mode-4');
    }
    if (scrollY <= 300) {
      header.classList.remove('mode-3');
    }
    if (scrollY <= 110) {
      header.classList.remove('mode-2');
    }
  });

  // 手機

  // 漢堡開關
  const hamburgerIcon = document.querySelector('.hamburger-icon');
  const navBoxMobile = document.querySelector('.nav-box-m');
  const navBoxCloseBtnMobile = document.querySelectorAll(
    '.nav-box-close-btn-mobile'
  );

  // 二階段開關
  const dropdownOpenBtnMobile = document.querySelector('.dropdown-btn-mobile');
  const dropdownInnerMobile = document.querySelector(
    '.dropdown-menu-inner-mobile'
  );
  const dropdownBackBtnMobile = document.querySelector('.back-dropdown-m-btn');

  hamburgerIcon.addEventListener('click', (e) => {
    e.stopPropagation();
    navBoxMobile.classList.add('show');
  });

  const { clickOutside } = window.$outsideClick;
  const navBoxInner = document.querySelector('.nav-box-inner');
  clickOutside({
    el: navBoxInner,
    handler: () => {
      navBoxMobile.classList.remove('show');
      dropdownInnerMobile.classList.remove('show');
    },
  });

  navBoxCloseBtnMobile.forEach((item) => {
    item.addEventListener('click', () => {
      navBoxMobile.classList.remove('show');
      dropdownInnerMobile.classList.remove('show');
    });
  });

  // 二階段開關
  dropdownOpenBtnMobile.addEventListener('click', () => {
    dropdownInnerMobile.classList.add('show');
  });

  dropdownBackBtnMobile.addEventListener('click', () => {
    dropdownInnerMobile.classList.remove('show');
  });
})();

// index kv切換
(() => {
  const pageIndex = document.querySelector('.page-index');
  if (!pageIndex) return;

  const kvImage = document.querySelectorAll('.kv-img');
  const circleLoad = document.querySelectorAll('.circle-load');
  const imgBox = document.querySelector('.img-box');
  let circleLoadIndex = 0;
  let currentIndex = 0;

  if (!imgBox || !kvImage || !circleLoad) {
    return;
  }

  function toggleShowClass() {
    currentIndex = (currentIndex + 1) % kvImage.length;
    kvImage.forEach((item, idx) => {
      if (idx === currentIndex) {
        item.classList.add('show');
      } else {
        item.classList.remove('show');
      }
    });
  }
  setInterval(toggleShowClass, 5000);

  function circleShowClass() {
    circleLoadIndex = (circleLoadIndex + 1) % circleLoad.length;
    circleLoad.forEach((item, idx) => {
      if (idx === circleLoadIndex) {
        item.classList.add('active');
      } else {
        item.classList.remove('active');
      }
    });
  }
  setInterval(circleShowClass, 5000);

  imgBox.addEventListener('click', () => {
    toggleShowClass();
    circleShowClass();
  });
})();

// index 經銷商開關
(() => {
  const pageIndex = document.querySelector('.page-index');
  if (!pageIndex) return;

  const distributorsOpenBtn = document.querySelectorAll(
    '.circle-animation-btn'
  );

  const distributorsMobile = document.querySelectorAll('.circle');

  const { clickOutside } = window.$outsideClick;

  distributorsOpenBtn.forEach((item) => {
    clickOutside({
      el: item,
      handler: (e, el) => {
        const circleNode = el.parentNode;
        const distributorsBox = circleNode.querySelector('.distributors-box');
        distributorsBox.classList.remove('show');
        distributorsMobile.forEach(() => {
          circleNode.classList.remove('show');
        });
      },
    });

    item.addEventListener('click', () => {
      const circleNode = item.parentNode;
      const distributorsBox = circleNode.querySelector('.distributors-box');
      if (window.screen.width <= 1000) {
        distributorsMobile.forEach(() => {
          circleNode.classList.add('show');
        });
      }
      distributorsBox.classList.add('show');
    });
  });
})();

// 共用 左側share
/*
(() => {
  const pageShareBox = document.querySelector('.page-share-box');
  if (!pageShareBox) return;

  const iconShare = document.querySelector('.icon-share');
  const iconCross = document.querySelector('.icon-cross');
  const shareBox = document.querySelector('.share-box');
  const fbTwitterWhatsapp = document.querySelector('.fb-twitter-whatsapp-box');

  if (!iconShare || !shareBox) {
    return;
  }

  shareBox.addEventListener('mouseenter', () => {
    iconShare.classList.remove('active');
    iconCross.classList.add('active');
    fbTwitterWhatsapp.classList.add('active');
  });

  shareBox.addEventListener('mouseleave', () => {
    iconCross.classList.remove('active');
    iconShare.classList.add('active');
    fbTwitterWhatsapp.classList.remove('active');
  });
})();
*/

// immersion-cooling-kit-c1 swiper
(() => {
  const page = document.querySelector('.page-cooling-kit-c1');
  if (!page) return;

  const ele = document.querySelector('.page-cooling-kit-c1 .mySwiper-01');

  const swiper = new Swiper(ele, {
    slidesPerView: 1,
    spaceBetween: 0,
    pagination: {
      el: '.swiper-pagination',
    },
  });
})();

// immersion-cooling-kit-c2 swiper
(() => {
  const page = document.querySelector('.page-cooling-kit-c2');
  if (!page) return;

  const ele = document.querySelector('.page-cooling-kit-c2 .mySwiper-01');

  const swiper = new Swiper(ele, {
    slidesPerView: 1,
    spaceBetween: 0,
    pagination: {
      el: '.swiper-pagination',
    },
  });
})();

// immersion-cooling-kit-b24 swiper
(() => {
  const page = document.querySelector('.page-immersion-cooling-kit-b24');
  if (!page) return;

  const ele = document.querySelector(
    '.page-immersion-cooling-kit-b24 .mySwiper-01'
  );

  const swiper = new Swiper(ele, {
    slidesPerView: 1,
    spaceBetween: 0,
    pagination: {
      el: '.swiper-pagination',
    },
  });
})();

// immersion-cooling-kit-c6 swiper
(() => {
  const page = document.querySelector('.page-cooling-kit-c6');
  if (!page) return;

  const ele = document.querySelector('.page-cooling-kit-c6 .mySwiper-01');

  const swiper = new Swiper(ele, {
    slidesPerView: 1,
    spaceBetween: 0,
    pagination: {
      el: '.swiper-pagination',
    },
  });
})();

// page-immersion-cooling-kit-m1designed-for-whatsminer-m56 swiper
(() => {
  const page = document.querySelector(
    '.page-immersion-cooling-kit-m1designed-for-whatsminer-m56'
  );
  if (!page) return;

  const ele = document.querySelector(
    '.page-immersion-cooling-kit-m1designed-for-whatsminer-m56 .mySwiper-01'
  );

  const swiper = new Swiper(ele, {
    slidesPerView: 1,
    spaceBetween: 0,
    pagination: {
      el: '.swiper-pagination',
    },
  });
})();

// page-fhc01-coolant swiper
(() => {
  const page = document.querySelector('.page-fhc01-coolant');
  if (!page) return;

  const ele = document.querySelector('.page-fhc01-coolant .mySwiper-01');

  const swiper = new Swiper(ele, {
    slidesPerView: 1,
    spaceBetween: 0,
    pagination: {
      el: '.swiper-pagination',
    },
  });
})();

// page-immersion-cooling-kit-m6-designed-for-whatsminer-m66-series swiper
(() => {
  const page = document.querySelector(
    '.page-immersion-cooling-kit-m6-designed-for-whatsminer-m66-series'
  );
  if (!page) return;

  const ele = document.querySelector(
    '.page-immersion-cooling-kit-m6-designed-for-whatsminer-m66-series .mySwiper-01'
  );

  const swiper = new Swiper(ele, {
    slidesPerView: 1,
    spaceBetween: 0,
    pagination: {
      el: '.swiper-pagination',
    },
  });
})();

// b-series-warehouse-based-solution swiper
(() => {
  const page = document.querySelector(
    '.page-b-series-warehouse-based-solution'
  );
  if (!page) {
    return;
  }

  const ele = document.querySelector(
    '.page-b-series-warehouse-based-solution .mySwiper-01'
  );

  const swiper = new Swiper(ele, {
    slidesPerView: 1,
    a11y: {
      prevSlideMessage: 'An arrow to switch previous icon of the left side',
      nextSlideMessage: 'An arrow to switch next icon of the right side',
    },
    pagination: {
      el: '.service-process .swiper-box-01 .swiper-pagination',
      clickable: true,
    },
    navigation: {
      nextEl: '.service-process .swiper-box-01 .swiper-button-next',
      prevEl: '.service-process .swiper-box-01 .swiper-button-prev',
    },
    breakpoints: {
      1001: {
        slidesPerView: 3,
        spaceBetween: 0,
      },
    },
  });
})();

// b-series-warehouse-based-solution swiper
(() => {
  const page = document.querySelector(
    '.page-b-series-warehouse-based-solution'
  );
  if (!page) {
    return;
  }

  const ele = document.querySelector(
    '.page-b-series-warehouse-based-solution .mySwiper-02'
  );

  const swiper = new Swiper(ele, {
    slidesPerView: 1,
    a11y: {
      prevSlideMessage: 'An arrow to switch previous icon of the left side',
      nextSlideMessage: 'An arrow to switch next icon of the right side',
    },
    pagination: {
      el: '.service-process .swiper-box-02 .swiper-pagination',
      clickable: true,
    },
    navigation: {
      nextEl: '.service-process .swiper-box-02 .swiper-button-next',
      prevEl: '.service-process .swiper-box-02 .swiper-button-prev',
    },
    breakpoints: {
      1001: {
        slidesPerView: 2,
        spaceBetween: 0,
      },
    },
  });
})();

// product-sell-box button變數
(() => {
  const productSellBox = document.querySelector('.product-sell-box');
  if (!productSellBox) return;

  const btnProduct = document.querySelectorAll(
    '.product-sell-box .btn-product'
  );
  const normalEle = document.querySelector('.product-sell-box .normal');
  const originalEle = document.querySelector('.product-sell-box .original');
  const priceDifferenceEle = document.querySelector(
    '.product-sell-box .price-difference'
  );
  const optionEle = document.querySelector('.product-sell-box .options-inner');
  const coinBox = document.querySelector('.product-sell-box .coin');

  const btnBuyCart = document.querySelector('.product-sell-box .btn-buy-cart');
  const btnBuyGoogle = document.querySelector(
    '.product-sell-box .btn-buy-google-box'
  );
  const btnSoldOut = document.querySelector('.product-sell-box .btn-sold-out');

  let soldOutEle = null;
  let currentBtnIndex = 0;

  const createSoldOutElement = () => {
    if (soldOutEle) {
      return;
    }

    soldOutEle = document.createElement('div');
    soldOutEle.classList.add('sold-out', 'active');
    soldOutEle.innerText = 'Sold out';
    coinBox.appendChild(soldOutEle);

    btnBuyCart.classList.remove('show');
    btnBuyGoogle.classList.remove('show');
    btnSoldOut.classList.add('show');
  };

  btnProduct.forEach((item, index) => {
    const originalCoin = item.getAttribute('data-original-coin') || '';
    const priceDifference = item.getAttribute('data-price-difference');
    const normal = item.getAttribute('data-normal');
    const option = item.getAttribute('data-option');
    const soldOut = item.getAttribute('data-soldOut');

    if (currentBtnIndex === index) {
      item.classList.add('active');
      normalEle.innerText = `$ ${normal}`;
      optionEle.innerText = option;

      if (originalCoin) {
        normalEle.classList.add('red');
        originalEle.innerText = originalCoin;
        priceDifferenceEle.classList.remove('active');
        priceDifferenceEle.innerText = `Save $ ${priceDifference}`;
      } else {
        normalEle.classList.remove('red');
        originalEle.innerText = '';
      }

      if (soldOut === '1') {
        createSoldOutElement();
      }
    }

    item.addEventListener('click', () => {
      btnProduct.forEach((btn) => btn.classList.remove('active'));
      normalEle.innerText = `$ ${normal}`;
      optionEle.innerText = option;
      item.classList.add('active');

      if (originalCoin) {
        normalEle.classList.add('red');
        originalEle.innerText = originalCoin;
        priceDifferenceEle.classList.remove('active');
        priceDifferenceEle.innerText = `Save $${priceDifference}`;
      } else {
        normalEle.classList.remove('red');
        originalEle.innerText = '';
        priceDifferenceEle.classList.add('active');
      }

      if (soldOut === '1') {
        createSoldOutElement();
      } else {
        if (soldOutEle) {
          coinBox.removeChild(soldOutEle);
          soldOutEle = null;

          btnBuyCart.classList.add('show');
          btnBuyGoogle.classList.add('show');
          btnSoldOut.classList.remove('show');
        }
      }
    });
  });

  btnProduct.forEach((btn) => {
    if (btn.getAttribute('data-soldOut') === '1') {
      btn.classList.add('active-2');
    }
  });
})();

// product-sell-box 數量
(() => {
  const productSellBox = document.querySelector('.product-sell-box');
  if (!productSellBox) return;

  const minusEle = document.querySelector('.btn-minus');
  const plusEle = document.querySelector('.btn-plus');
  const counterEle = document.querySelector('.group-bottom .num');

  let counterValue = 0;

  const updateCounter = () => {
    counterEle.innerText = counterValue;
  };

  minusEle.addEventListener('click', () => {
    if (counterValue > 0) {
      counterValue -= 1;
      updateCounter();
    }
  });

  plusEle.addEventListener('click', () => {
    counterValue += 1;
    updateCounter();
  });

  updateCounter();
})();

// 規格表單 展開 收回
(() => {
  const productSpecification = document.querySelector('.product-specification');
  if (!productSpecification) return;

  const btnOpen = document.querySelectorAll('.product-specification .btn-open');
  const btnClose = document.querySelectorAll(
    '.product-specification .btn-close'
  );

  btnOpen.forEach((item) => {
    item.addEventListener('click', (e) => {
      const clickedElement = e.currentTarget;
      const btnBox = clickedElement.parentNode;
      const rightSpecificationBox = clickedElement.parentNode.parentNode;

      rightSpecificationBox
        .querySelector('.specification-wrapper')
        .classList.add('active');

      btnBox.querySelector('.btn-open').classList.remove('active');
      btnBox.querySelector('.btn-close').classList.add('active');
    });
  });

  btnClose.forEach((item) => {
    item.addEventListener('click', (e) => {
      const clickedElement = e.currentTarget;
      const btnBox = clickedElement.parentNode;
      const rightSpecificationBox = clickedElement.parentNode.parentNode;

      console.log(
        rightSpecificationBox.querySelector('.specification-wrapper')
      );
      rightSpecificationBox
        .querySelector('.specification-wrapper')
        .classList.remove('active');
      btnBox.querySelector('.btn-open').classList.add('active');
      btnBox.querySelector('.btn-close').classList.remove('active');
    });
  });
})();

// faq 展開 收回
(() => {
  const productSpecification = document.querySelector('.product-specification');
  if (!productSpecification) return;

  const btnOpen = document.querySelectorAll('.specification-info .btn-open');
  const btnClose = document.querySelectorAll('.specification-info .btn-close');

  btnOpen.forEach((item) => {
    item.addEventListener('click', (e) => {
      const clickedElement = e.currentTarget;
      const btnBox = clickedElement.parentNode;
      const wrapperEle =
        clickedElement.parentNode.parentNode.parentNode.parentNode.parentNode;

      wrapperEle.classList.add('active');

      btnBox.querySelector('.btn-open').classList.remove('active');
      btnBox.querySelector('.btn-close').classList.add('active');
    });
  });

  btnClose.forEach((item) => {
    item.addEventListener('click', (e) => {
      const clickedElement = e.currentTarget;
      const btnBox = clickedElement.parentNode;
      const wrapperEle =
        clickedElement.parentNode.parentNode.parentNode.parentNode.parentNode;

      wrapperEle.classList.remove('active');
      btnBox.querySelector('.btn-open').classList.add('active');
      btnBox.querySelector('.btn-close').classList.remove('active');
    });
  });
})();

// you also like 燈箱
(() => {
  const alsoLike = document.querySelector('.also-like');
  if (!alsoLike) return;

  // 產品卡
  const productLightBox = document.querySelector('.product-light-box');
  const btnCartOpenLightBox = document.querySelectorAll('.icon-cart-box');
  const btnQuickAddOpenLightBox = document.querySelectorAll('.quick-add-box');

  // 開啟
  btnQuickAddOpenLightBox.forEach((item) => {
    item.addEventListener('click', () => {
      const dataProductItem = item.getAttribute('data-productItem');

      if (dataProductItem) {
        productLightBox.classList.add('active');
        document.querySelector(`.${dataProductItem}`)?.classList.add('active');
        document
          .querySelector(`.${dataProductItem}`)
          ?.querySelector('.btn-product')
          .click();
      }
    });
  });

  btnCartOpenLightBox.forEach((item) => {
    item.addEventListener('click', () => {
      const dataProductItem = item.getAttribute('data-productItem');

      if (dataProductItem) {
        productLightBox.classList.add('active');
        document.querySelector(`.${dataProductItem}`)?.classList.add('active');
        document
          .querySelector(`.${dataProductItem}`)
          ?.querySelector('.btn-product')
          .click();
      }
    });
  });

  // 關閉
  const btnCloseLightBox = document.querySelectorAll('.btn-close-light-box');
  const productLightBoxItem = document.querySelectorAll(
    '.product-light-box-item'
  );

  btnCloseLightBox.forEach((item) => {
    item.addEventListener('click', () => {
      productLightBox.classList.remove('active');
      productLightBoxItem.forEach((item) => {
        item.classList.remove('active');
      });
    });
  });

  // 自行添加特價標籤
  const onSaleBoxEle = document.querySelectorAll('.on-sale-box');
  const originalEleList = document.querySelectorAll('.model-box .original');

  originalEleList.forEach((originalEle, index) => {
    const item = onSaleBoxEle[index];
    if (originalEle.textContent.trim().length > 0) {
      item.classList.add('active');
      const saleText = document.createElement('div');
      saleText.classList.add('text');
      saleText.innerText = 'On Sale';
      item.appendChild(saleText);
    }
  });

  // 燈箱
  const btnOption = document.querySelectorAll(
    '.product-light-box .btn-product'
  );

  btnOption.forEach((item) => {
    item.addEventListener('click', (e) => {
      const currentEle = e.currentTarget;
      btnOption.forEach((item) => {
        item.classList.remove('active');
      });

      currentEle.classList.add('active');

      const dataNormal = currentEle.getAttribute('data-normal');
      const dataOption = currentEle.getAttribute('data-option');
      const dataOriginalCoin =
        currentEle.getAttribute('data-original-coin') || '';
      const dataPriceDifference = currentEle.getAttribute(
        'data-price-difference'
      );

      const currentParentNode = currentEle.parentNode.parentNode;
      const optionInnerText = currentParentNode.querySelector('.options-inner');
      const originalInnerText = currentParentNode.querySelector('.original');
      const normalCoinInnerText = currentParentNode.querySelector('.normal');
      const priceDifferenceInnerText =
        currentParentNode.querySelector('.price-difference');

      optionInnerText.innerText = dataOption;
      normalCoinInnerText.innerText = `$ ${dataNormal}`;

      if (dataOriginalCoin) {
        normalCoinInnerText.classList.add('red');
        originalInnerText.innerText = `$ ${dataOriginalCoin}`;
        priceDifferenceInnerText.classList.remove('active');
        priceDifferenceInnerText.innerText = `Save $ ${dataPriceDifference}`;
      } else {
        normalCoinInnerText.classList.remove('red');
        originalInnerText.innerText = '';
        priceDifferenceInnerText.classList.add('active');
      }
    });
  });
})();

// YT影片自製撥放鍵
(() => {
  let isPlay = false;
  let myPlayer;
  // import winnerList from "./list.json"

  function YTload() {
    var tag = document.createElement('script');
    tag.src = 'https://www.youtube.com/iframe_api';
    var firstScriptTag = document.getElementsByTagName('script')[0];
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
  }

  window.onYouTubeIframeAPIReady = function () {
    const ytPlayer = document.querySelector('#yt-player');
    if (!ytPlayer) {
      return;
    }

    const YTcode = ytPlayer.getAttribute('data-YTcode');

    myPlayer = new YT.Player(ytPlayer, {
      height: '100%',
      width: '100%',
      videoId: YTcode,
      playerVars: {
        rel: 0,
        loop: 1,
        playsinline: 1,
        modestbranding: 1,
        iv_load_policy: 3,
      },
      events: {
        onReady: onPlayerReady,
        onStateChange: onPlayerStateChange,
      },
    });
  };

  function onPlayerReady(event) {
    // event.target.mute()
    // event.target.playVideo()
  }

  function onPlayerStateChange(event) {
    if (event.data == YT.PlayerState.PLAYING) {
      isPlay = true;
    } else {
      isPlay = false;
    }
  }

  YTload();

  const btnYtPlayer = document.querySelector('.btn-yt-player');
  const textBox = document.querySelector('.yt-video-inner-box');

  if (!btnYtPlayer) {
    return;
  }

  btnYtPlayer.addEventListener('click', () => {
    textBox.classList.remove('active');
    myPlayer.playVideo();
  });
})();

// // immersion-cooling-kit-c6 圖片捲動
(() => {
  const section = document.querySelector('.images-with-text-scrolling');
  if (!section) return;

  const imageBox = section.querySelector('.image-box');

  imageBox.innerHTML = '';
  section.querySelectorAll('.card .image img').forEach((img) => {
    imageBox.appendChild(img.cloneNode(true));
  });

  window.addEventListener('scroll', onScroll);
  onScroll();

  function onScroll() {
    const imgHeight = imageBox.clientHeight;
    const cards = section.querySelectorAll('.card');

    for (let i = 1; i <= cards.length; i++) {
      if (cards[i - 1].getBoundingClientRect().top < 120 + imgHeight) {
        imageBox.classList.add(`mode-${i}`);
      } else {
        imageBox.classList.remove(`mode-${i}`);
      }
    }
  }
})();

// slide-image-box
(() => {
  const slideImageBox = document.querySelectorAll('.slide-image-box');
  if (!slideImageBox) {
    return;
  }

  slideImageBox.forEach((elBox) => {
    const elBar = elBox.querySelector('.slide-image-box__bar');
    const elTop = elBox.querySelector('.slide-image-box__top');
    let isDown = false;

    elBar.addEventListener('mousedown', (e) => {
      isDown = true;
      elBar.classList.add('active');
    });

    document.addEventListener('mouseup', (e) => {
      isDown = false;
      elBar.classList.remove('active');
    });

    document.addEventListener('mousemove', (e) => {
      if (!isDown) {
        return;
      }

      const boxWidth = elBox.offsetWidth;
      const mouseX = e.pageX - elBox.offsetLeft;
      const percent = mouseX / boxWidth;
      const limitPercent = Math.min(Math.max(percent, 0), 1);

      elBar.style.left = limitPercent * 100 + '%';
      elTop.style.width = limitPercent * 100 + '%';
    });
  });
})();

// num-ani
(() => {
  const numAni = document.querySelectorAll('.num-ani');

  numAni.forEach((item) => {
    const startNum = Number(item.getAttribute('data-start')) || 0;
    const endNum = Number(item.getAttribute('data-end')) || 0;
    const times = Number(item.getAttribute('data-times')) || 80;
    const fraction = Number(item.getAttribute('data-fraction')) || 0;

    item.textContent = startNum;
    const step = (endNum - startNum) / times;

    let num = startNum;
    window.addEventListener('scroll', scrollFn);
    function scrollFn() {
      const scrollY = window.scrollY;
      const windowHeight = window.innerHeight;
      const itemTop = item.offsetTop;
      const itemHeight = item.offsetHeight;
      const itemBottom = itemTop + itemHeight;
      if (scrollY + windowHeight >= itemTop && scrollY <= itemBottom) {
        requestAnimationFrame(stepFn);
        window.removeEventListener('scroll', scrollFn);
      }
    }

    function stepFn() {
      num += step;
      item.textContent = num.toFixed(fraction);
      if (num < endNum) {
        requestAnimationFrame(stepFn);
      } else {
        item.textContent = endNum.toFixed(fraction);
      }
    }
  });
})();
